import { render, staticRenderFns } from "./firstReviewList_wx.vue?vue&type=template&id=45a1bdc1&scoped=true"
import script from "./firstReviewList_wx.vue?vue&type=script&lang=js"
export * from "./firstReviewList_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a1bdc1",
  null
  
)

export default component.exports